import {React,useEffect, useState} from 'react';
import './CustomDialogViewing.css'; // Custom styles for the dialog

const CustomDialogForDocumentsViewing = ({
  isOpen,
  onClose,
  documents,
  pod,
  PodRemark,
  trackingType,
  onTabChange,
  selectedTab
}) => {
  if (!isOpen) return null;

  const [selectedViewTab, setSelectedViewTab] = useState('loading');

  useEffect(() => {
    if (selectedTab && selectedTab !== selectedViewTab) {
      setSelectedViewTab(selectedTab);
    }
  }, [selectedTab]);

  // Handle tab click
  const handleTabClick = (tab) => {
    setSelectedViewTab(tab); // Update the selected tab
    onTabChange(tab); // Notify parent to fetch corresponding documents
  };
  

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2 className="dialog-title">{pod ? 'View POD Documents' : 'View Documents'}</h2>
        </div>
        {trackingType === 'FTL' && (
          <div className="tabs-section">
            <ul className="tabs">
              <li
                className={`tab-item ${selectedViewTab === 'loading' ? 'active' : ''}`}
                onClick={() => handleTabClick('loading')}
              >
                Loading
              </li>
              <li
                className={`tab-item ${selectedViewTab === 'unloading' ? 'active' : ''}`}
                onClick={() => handleTabClick('unloading')}
              >
                Unloading
              </li>
            </ul>
          </div>
        )}
        <div className="dialog-body">
          {documents?.length > 0 ? (
            <div className="document-card">
              <ul className="document-list">
                
                {documents.map((doc, index) => {
                  const displayFileName = doc.fileName.replace('uploads/legrand_', '');
                  return (
                    <li key={index} className="document-item">
                      <div className='d-flex'>
                      <a
                        href={doc.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="attachment-link"
                        title="View Document"
                      >
                        <i className="fa fa-paperclip attachment-icon"></i>
                      </a>
                      <input
                        type="text"
                        value={displayFileName}
                        readOnly
                        className="file-input"
                      />
                      </div>
                      {(PodRemark || doc.loadingdocremarks || doc.doc_remarks) && (
                        <div className="remarks-section">
                          <p className="remark-text">  Remarks: {PodRemark ? PodRemark : doc.loadingdocremarks ? doc.loadingdocremarks : doc.doc_remarks}
                          </p>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : (
            <p className="doc-style">No documents available.</p>
          )}
        </div>
        <div className="dialog-actions">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};


export default CustomDialogForDocumentsViewing;